<script setup lang="ts">
defineOptions({
  name: 'Ui2CarouselSlide',
});
</script>

<template>
  <li class="ui-carousel__slide">
    <slot />
  </li>
</template>
